export default {
      id: "ic_fast_deposit_iban_close-usage",
      viewBox: "0 0 24 24",
      url: "/" + "images/icons.3.109.2.svg#ic_fast_deposit_iban_close-usage",
      toString: function () {
        return this.url;
      }
    }